import { downloadBusProps, emitToast } from './emitToast'

/**
 * Triggers a browser download for an in-memory blob using the standard
 * anchor + objectURL + revoke pattern, then emits a download toast. Pass
 * `message` to override the default toast text (e.g. to include dimensions).
 */
export const triggerBlobDownload = (blob: Blob, filename: string, message = `${filename} downloaded.`) => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return
  }

  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()

  requestAnimationFrame(() => {
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
    emitToast({
      message,
      ...downloadBusProps,
    })
  })
}

export const handlePdfDownload = async (blob: Blob, contentDisposition: string | null) => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return
  }

  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url

  let filename = 'download.pdf'

  if (contentDisposition) {
    const filenameStarMatch = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition)
    if (filenameStarMatch?.[1]) {
      try {
        filename = decodeURIComponent(filenameStarMatch[1])
      } catch (error) {
        console.warn('Error decoding filename*:', error)
        const filenameMatch = /filename="([^"]+)"/i.exec(contentDisposition)
        if (filenameMatch?.[1]) {
          filename = filenameMatch[1]
        }
      }
    } else {
      // Fallback to the simple filename attribute
      const filenameMatch = /filename="([^"]+)"/i.exec(contentDisposition)
      if (filenameMatch?.[1]) {
        filename = filenameMatch[1]
      }
    }
  }

  a.download = filename
  document.body.appendChild(a)
  a.click()

  requestAnimationFrame(() => {
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
    emitToast({
      message: 'PDF downloaded.',
      ...downloadBusProps,
    })
  })
}
